// Page + rows-per-page state for a server-paginated list, in one place so
// every list in ops behaves the same: 25 rows by default, the reader can
// widen to 50 or 100, and changing the size lands back on page 1 (page 3 of
// a 25-row list is not page 3 of a 100-row one).
//
// The caller still resets `page` when its own filters change; the hook
// cannot know what a filter is. `pagination(total)` is the DataTable prop.

import { useCallback, useState } from 'react';
import type { DataTablePagination } from '@drivecars/admin-ui';

export const DEFAULT_PAGE_SIZE = 25;

export function usePager(defaultLimit: number = DEFAULT_PAGE_SIZE) {
  const [page, setPage] = useState(1);
  const [limit, setLimitState] = useState(defaultLimit);
  const setLimit = useCallback((next: number) => {
    setLimitState(next);
    setPage(1);
  }, []);
  const pagination = useCallback(
    (total: number): DataTablePagination => ({ page, limit, total, onPageChange: setPage, onLimitChange: setLimit }),
    [page, limit, setLimit],
  );
  return { page, setPage, limit, setLimit, pagination };
}
